module.exports = __webpack_public_path__ + "img/security2-logo42.c917c564.png";